import React from "react";
import { Helmet } from "react-helmet-async";
import Card from "@mui/material/Card";

import InformationHome from "pages/Servicii/ServiciiCuratenie/CurateniePostConstruct/sections/sections/InformationHome";
import TestimonialsHome from "pages/Homepage/sections/TestimonialsHome";
import ArticleContent from "pages/Servicii/ServiciiCuratenie/CurateniePostConstruct/sections/sections/ArticleContent";
import HeroSection from "pages/Servicii/ServiciiCuratenie/CurateniePostConstruct/sections/sections/HeroSection";
import ServicesSection from "pages/Servicii/ServiciiCuratenie/CurateniePostConstruct/sections/sections/Services";

function CurateniePostConstruct() {
    return (
        <>
            <Helmet>
                <title>Curățenie Post-Construct | Doral Cleaning București &amp; Ilfov</title>
                <meta
                    name="description"
                    content="Scapă de praful și resturile după șantier. Oferim servicii profesionale de curățenie post-construct pentru apartamente, vile și spații comerciale."
                />
                <link rel="canonical" href="https://doral-cleaning.ro/curatenie-post-construct/" />
                <script type="application/ld+json">
                    {`
                    {
                      "@context": "https://schema.org",
                      "@type": "LocalBusiness",
                      "name": "Doral Cleaning - Servicii profesionale de curatenie",
                      "image": "",
                      "@id": "",
                      "url": "",
                      "telephone": "0730 407 322",
                      "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "Calea Șerban Vodă 82, Sector 4, 040213 București",
                        "addressLocality": "",
                        "postalCode": "",
                        "addressCountry": ""
                      },
                      "geo": {
                        "@type": "GeoCoordinates",
                        "latitude": 44.4202372718721,
                        "longitude": 26.10209372955662
                      }  
                    }
                    `}
                </script>
            </Helmet>
            <HeroSection />
            <Card
                sx={{
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    zIndex: 1,
                    backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
                        rgba(white.main, 0.8),
                    backdropFilter: "saturate(200%) blur(30px)",
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <TestimonialsHome />
                <InformationHome />
                <ArticleContent />
                <ServicesSection />
            </Card>
        </>
    );
}

export default CurateniePostConstruct;
